<template>
  <div>
    <v-card>
      <v-card-text>
        <table>
          <tbody>
            <tr v-for="(register, r) in course_clothes" :key="r">
              <td>{{ register.course.name }}</td>
              <td>
                <table v-if="register.course.clothes.length > 0">
                  <tbody>
                    <tr
                      v-for="(clothe, c) in register.course.clothes"
                      :key="c"
                    >
                      <td>{{ clothe.clothe.name }}</td>
                      <td>
                        <v-img
                          :src="clothe.clothe.files.length > 0 && clothe.clothe.files[0].file_url"
                          width="100px"
                        ></v-img>
                      </td>
                      <td>
                        <v-radio-group
                          v-model="course_clothe_selected[`${register.course.id}-${clothe.clothe.id}`]"
                          :key="`${register.id}-${clothesSelected}`">
                          <v-radio
                            v-for="(size, s) in clothe.clothe.sizes" :key="s"
                            :label="size.size.name"
                            :value="`${size.clothe_id}-${size.size.id}`"
                            @change="selectSize(register.id, `${size.clothe_id}-${size.size.id}`)"
                          ></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-btn
                          v-if="course_clothe_selected[`${register.course.id}-${clothe.clothe.id}`]"
                          flat
                          icon
                          color="error"
                          @click="removeClothe(register.id, clothe.clothe.id, register.course.id)"
                          >
                          <v-icon>close</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span v-else>
                  Este curso no tiene uniforme.
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'course-clothes-detail-view',
    props: {
      course_clothes: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        course_clothe_selected: {}
      }
    },
    computed: {
      clothesSelected() {
        return Object.keys(this.course_clothe_selected).length
      }
    },
    watch: {
      course_clothes(value) {
        if (value) {
          let data = {}
          value.forEach(register => {
            register.clothes.forEach(clothe => {
              data[`${register.course.id}-${clothe.clothe_id}`] = `${clothe.clothe_id}-${clothe.clothe_size_id}`
            })
          });
          console.log(data)
          this.course_clothe_selected = data
          return
        }
      }
    },
    methods: {
      selectSize(reserve_id, clothe_key) {

        const clothes_sizes_id = clothe_key.split('-')
        const clothe_id = clothes_sizes_id[0]
        const clothe_size_id = clothes_sizes_id[1]
        const data = {
          reserve_id,
          clothe_id,
          clothe_size_id,
        }
        axios.post('/api/extracurriculares/enrollment/clothes', data )
          .then(resp => {
            if (resp.status === 200) {

            }
          })
          .catch(err => console.log(err))

      },
      removeClothe(reserve_id, clothe_id, course_id) {

        axios.delete(`/api/extracurriculares/enrollment/clothes/${reserve_id}/${clothe_id}`)
          .then(resp => {
            if (resp.status === 200) {
              this.$emit('refreshClothes')
            }
          })
          .catch(error => console.log(error))
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/course_clothes.vue